export default __webpack_public_path__ + "static/GPS-5e2ebfa44c83b623b6938883d78beef2.png";